import React from 'react'
import { Modal } from '@web/walter-ui-kit'
import Content from './Content'

interface Props {
    isOpen: boolean
    onClose: () => void
}

function KycModal({ isOpen, onClose }: Props) {
    return (
        <Modal
            withHeaderBorder={false}
            onClose={onClose}
            isOpen={isOpen}
            type="dialog"
            dataPointer="kyc_modal"
            size="xs"
        >
            <Content onClose={onClose} />
        </Modal>
    )
}

export default KycModal
